export const assets = {
  hero: '/assets/jit-hero-A1GJo4Bd.webp',
  about: '/assets/jit-about-CQAhZr0j.webp',
  venture: '/assets/jit-venture-BXATuQkD.webp',
  experience: '/assets/jit-experience-kK4Z5Uar.webp',
  expertise: '/assets/jit-expertise-BrRFbO0r.webp',
  ai: '/assets/jit-ai-BEBt4C2r.webp',
  contact: '/assets/jit-contact-BYr3nveo.webp',
  work: '/assets/jit-contact-BYr3nveo.webp',
  portraits: {
    hero: '/assets/jit-hero-A1GJo4Bd.webp',
    about: '/assets/jit-about-CQAhZr0j.webp',
    venture: '/assets/jit-venture-BXATuQkD.webp',
    experience: '/assets/jit-experience-kK4Z5Uar.webp',
    expertise: '/assets/jit-expertise-BrRFbO0r.webp',
    ai: '/assets/jit-ai-BEBt4C2r.webp',
    contact: '/assets/jit-contact-BYr3nveo.webp',
    work: '/assets/jit-contact-BYr3nveo.webp',
  },
};

export const assetUrls = assets;
